"use client";

import { BackendButton } from "@/app/components/backend/backend-ui";
import { Loader2 } from "lucide-react";
import { useFormStatus } from "react-dom";

type ResendConfirmationButtonPropsT = {
  /** Blocks submitting an empty form before the action is even called. */
  disabled?: boolean;
};

export function ResendConfirmationButton({
  disabled,
}: ResendConfirmationButtonPropsT) {
  const { pending } = useFormStatus();

  return (
    <BackendButton
      type="submit"
      disabled={pending || disabled}
      className="mt-2 h-12 w-full text-[15px]"
    >
      {pending && <Loader2 className="h-4 w-4 animate-spin" />}
      <span>{pending ? "Wird gesendet" : "Bestätigungslink senden"}</span>
    </BackendButton>
  );
}
